import React from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import PostCard from './post-card';
import {Loading} from "../../components/Loading";
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';


const PostList = ({ endpoint, queryParams = "" }) => {

  const [myErrors, setMyErrors] = React.useState('');
  const {t} = useTranslation("post")
  const translation = t('post-list')

  const fetchPosts = async ({ pageParam = 1 }) => {
    
    try {
      const token = localStorage.getItem('access_token');
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_DOMAIN}${endpoint}?page=${pageParam}${queryParams ? `&${queryParams}` : ''}`,
        { headers }
      );

      if (!response.ok) {
        setMyErrors(`${translation.no_resp}`);
      }

      return await response.json();
    } catch (error) {
      setMyErrors(`${translation.server_error}`);
    }
  };

  // Use a memo for the query key to prevent unnecessary refetches
  const queryKey = React.useMemo(() => ['posts', endpoint, queryParams], [endpoint, queryParams]);

  
  const {
    data,
    isLoading,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery({
    queryKey,
    queryFn: ({ pageParam = 1 }) => fetchPosts({ pageParam }),
    getNextPageParam: (lastPage) => {
      return lastPage?.next ? lastPage.next : undefined;
    },
    refetchOnWindowFocus: false,
    staleTime: 60000,
  }); 
  
  const heading = () => {
    if ("/post/get-posts/" === endpoint) {
      return `${translation.home_heading}`;
    } 
    else if ("/post/get-user-save-posts/" === endpoint) {
      return `${translation.save_heading}`;
    }
    else if ("/post/get-user-history/" === endpoint) {
      return `${translation.history_heading}`;
    } 
    else if ("/post/filter-posts/" === endpoint) {
      return `${translation.filter_heading}`;
    }
    else if ("/post/get-satisfied-posts/" === endpoint) {
      return `${translation.satisfied_heading}`;
    }
    else {
      return `${translation.other_heading}`;
    }
  };

  return (

    <>
      <Helmet>
        <title>AddaZakat: The easiest way to pay Zakat</title>
        <meta name="description" content="AddaZakat is an Islamic charity platform. Pay Zakat online or donate directly to support poor families in need, with transparency and authentic stories." />
        <meta
          name="keywords"
          content="About Adda zakat foundation, AddaZakat, Zakat, Islamic Charity, Donations, Charity Platform, Needy Families, Medical Assistance, Masajid Support, Orphans Support, Sadaqah, Verified Donations, Who are Adda Zakat, online zakat payment, zakat fund online registration pakistan,how to donate zakat, zakat form, how to pay zakat online, i need zakat help in pakistan, apply for zakat fund in pakistan, zakat fund help request online, zakat near me, donate zakat online, give zakat online, pay zakat online, donate zakat pakistan, zakat donation portal, online zakat, zakat pakistan, zakat fund, zakat donations, zakat in islam, muslim zakat, zakat fund in pakistan, who is eligible for fitrana, sadaqah online, fidya rules, fitrana amount, when to pay zakat, how to give zakat in islam, how to pay zakat, when should i pay zakat, 1 lakh par kitni zakat hai, zakat donation reviews, donor feedback, zakat success stories, contact adda zakat, zakat helpline, zakat support, charity contact pakistan, donate zakat online, give zakat online, pay zakat online, donate zakat pakistan, zakat donation portal, online zakat, zakat pakistan, zakat fund, zakat donations, zakat in islam, muslim zakat, zakat fund in pakistan"
        />
        <meta name="author" content="AddaZakat Team" />
        <meta name="robots" content="index, follow" />

        <link rel="canonical" href={window.location.href} />


        <meta property="og:type" content="website" />
        <meta property="og:title" content="AddaZakat: Islamic Charity Platform for Direct Zakat Giving" />
        <meta property="og:description" content="AddaZakat is an Islamic charity platform. Pay Zakat online or donate directly to support poor families in need, with transparency and authentic stories." />
        <meta property="og:image" content="https://addazakat.com/logo.png" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="AddaZakat: Islamic Charity Platform for Direct Zakat Giving" />
        <meta name="twitter:description" content="AddaZakat is an Islamic charity platform. Pay Zakat online or donate directly to support poor families in need, with transparency and authentic stories." />
        <meta name="twitter:image" content="https://addazakat.com/logo.png" />
      </Helmet>

      <div className="mt-16 md:mx-5 ">


        {isLoading ? ( 
          <Loading />
        ) : ( 
            <>
              <div className="grid grid-cols-1 gap-5 max-w-2xl">
          
                <h2 className='text-xl font-bold dark:text-white '>
                  {heading()}
                </h2>

                {data?.pages?.some((page) => page?.results?.length) ? (
                  data.pages.map((page) =>
                    page?.results?.map((post) => (
                      <PostCard key={post.id} post={post} />
                    ))
                  )
                ) : (
                  <div className="flex justify-center text-xl border border-gray-400 bg-green-100 text-center rounded p-5 dark:bg-slate-400 font-bold">
                    {myErrors || `${translation.no_post_found}`}
                  </div>
                )}

                {hasNextPage && (
                  <button
                    className="w-full mb-5 p-3 rounded-full bg-gray-700 text-white dark:bg-gray-600 hover:bg-gray-400 dark:text-white font-bold "
                    onClick={() => fetchNextPage()}
                    disabled={isFetchingNextPage}
                  >
                    {isFetchingNextPage ? `${translation.loading}` : `${translation.load_more}`}
                  </button>
                )}
                
              </div>

              
            </>
          )
        }

      </div>

      
    </>

  );
};

export default PostList;